import { useRef, useId, useState, useEffect } from 'react';
import { filterOptionsByQuery, FocusOn, Search, Listbox, Button } from '@ui/kit';
import { containerCls, headingCls, searchCls, listboxCls, buttonsCls } from './_select-panel.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function SelectPanel(props) {
  const containerRef = useRef(null);
  const listboxId = `listbox-${useId()}`;
  const labelId = `label-${useId()}`;
  const [query, setQuery] = useState("");
  const [sortedOptions, setSortedOptions] = useState(props.options);
  useEffect(() => {
    setSortedOptions(filterOptionsByQuery(props.options, query));
  }, [props.options, query]);
  return /*#__PURE__*/jsx(FocusOn, {
    onEscapeKey: props.onCancel,
    returnFocus: true,
    noIsolation: true,
    allowPinchZoom: true,
    preventScrollOnFocus: true,
    children: /*#__PURE__*/jsxs("div", {
      tabIndex: 0,
      ref: containerRef,
      className: containerCls,
      children: [/*#__PURE__*/jsx("h4", {
        id: labelId,
        className: headingCls,
        children: props.label
      }), /*#__PURE__*/jsx(Search, {
        theme: "local",
        "aria-label": props.inputPlaceholder,
        placeholder: props.inputPlaceholder,
        className: searchCls,
        onQueryChange: setQuery
      }), /*#__PURE__*/jsx(Listbox, {
        toggleValue: props.toggleValue,
        selectedValues: props.selectedValues,
        options: sortedOptions,
        className: listboxCls,
        id: listboxId,
        labelledBy: labelId,
        multiSelect: props.multiSelect
      }), /*#__PURE__*/jsxs("div", {
        className: buttonsCls,
        children: [/*#__PURE__*/jsx(Button, {
          theme: "secondary",
          onClick: props.onCancel,
          children: "Annuller"
        }), /*#__PURE__*/jsx(Button, {
          theme: "primary",
          onClick: props.onSave,
          children: "V\xE6lg"
        })]
      })]
    })
  });
}

export { SelectPanel };
//# sourceMappingURL=_select-panel.js.map
